

var _squid = require('squid');

require('./directive');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$XOAddBankRoute', function () {
    return _squid.$ComponentRoute.extend('AddRoute', {
        name: 'add',
        titleContent: 'asideHeader.addBank',
        directive: 'xo-add-bank',
        trackingData: {
            fptiState: 'add_bank'
        },
        loginRequired: true,
        children: []
    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-bank/addbank/route.js
// module id = ../node_modules/xo-wallet-components/src/add-bank/addbank/route.js
// module chunks = 0